import { render, staticRenderFns } from "./BusquedaNombreTutores.vue?vue&type=template&id=60422968&scoped=true"
import script from "./BusquedaNombreTutores.vue?vue&type=script&lang=js"
export * from "./BusquedaNombreTutores.vue?vue&type=script&lang=js"
import style0 from "./BusquedaNombreTutores.vue?vue&type=style&index=0&id=60422968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60422968",
  null
  
)

export default component.exports